import { render } from "./yxt_index_new.vue?vue&type=template&id=4e611189&scoped=true"
import script from "./yxt_index_new.vue?vue&type=script&lang=js"
export * from "./yxt_index_new.vue?vue&type=script&lang=js"

import "./yxt_index_new.vue?vue&type=style&index=0&id=4e611189&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e611189"]])

export default __exports__